import React from 'react';
import { Level } from '../types';

interface ResultPageProps {
  result: any;
  level: Level;
  onRetry: () => void;
  onBack: () => void;
}

const ResultPage: React.FC<ResultPageProps> = ({
  result,
  level,
  onRetry,
  onBack
}) => {
  const getResultMessage = () => {
    if (result.passed) {
      if (result.stars === 3) return '🎉 太棒了！完美通关！';
      if (result.stars === 2) return '👏 恭喜通过！继续加油！';
      return '✅ 刚好通过！可以再挑战一下更高分！';
    }
    return '😅 差一点点，再试一次吧！';
  };

  const getResultColor = () => {
    if (result.passed) {
      return result.stars === 3 ? '#10b981' : '#3b82f6';
    }
    return '#ef4444';
  };

  return (
    <div className="fade-in">
      <div className="header" style={{
        background: `linear-gradient(135deg, ${getResultColor()} 0%, ${getResultColor()}dd 100%)`
      }}>
        <h1>{result.passed ? '🎊 闯关成功' : '💪 继续努力'}</h1>
        <div className="subtitle">{level.title}</div>
      </div>

      <div className="main-content">
        {/* 结果卡片 */}
        <div className="result-card">
          {/* 星级评价 */}
          <div className="result-stars">
            {result.stars === 0 ? '☆☆☆' : '⭐'.repeat(result.stars)}
            {result.stars < 3 ? '☆'.repeat(3 - result.stars) : ''}
          </div>

          {/* 分数 */}
          <div className="result-score" style={{ color: getResultColor() }}>
            {result.score}
          </div>
          <div className="result-accuracy">
            正确率 {result.accuracy}% · {result.correctCount}/{result.totalQuestions}题
          </div>

          {/* 结果信息 */}
          <div style={{
            background: '#f9fafb',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '24px'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '24px', fontWeight: '600', color: '#3b82f6' }}>
                  {result.correctCount}
                </div>
                <div style={{ fontSize: '12px', color: '#6b7280' }}>正确</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '24px', fontWeight: '600', color: '#ef4444' }}>
                  {result.totalQuestions - result.correctCount}
                </div>
                <div style={{ fontSize: '12px', color: '#6b7280' }}>错误</div>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '24px', fontWeight: '600', color: '#8b5cf6' }}>
                  {Math.floor(result.timeSpent / 60)}:{(result.timeSpent % 60).toString().padStart(2, '0')}
                </div>
                <div style={{ fontSize: '12px', color: '#6b7280' }}>用时</div>
              </div>
            </div>
          </div>

          {/* 结果消息 */}
          <div className="result-message" style={{ color: getResultColor() }}>
            {getResultMessage()}
          </div>

          {/* 通过状态 */}
          <div style={{
            padding: '16px',
            background: result.passed ? '#d1fae5' : '#fee2e2',
            borderRadius: '12px',
            marginBottom: '24px'
          }}>
            <div style={{
              fontSize: '18px',
              fontWeight: '600',
              color: result.passed ? '#065f46' : '#991b1b',
              marginBottom: '8px'
            }}>
              {result.passed ? '🎯 已解锁下一关' : '📚 需要达到75%正确率'}
            </div>
            <div style={{
              fontSize: '14px',
              color: result.passed ? '#047857' : '#b91c1c'
            }}>
              {result.passed 
                ? '恭喜！你已经准备好迎接新的挑战了！' 
                : '别灰心，多练习一下再来挑战！'}
            </div>
          </div>

          {/* 操作按钮 */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <button
              className="btn btn-primary"
              onClick={onRetry}
              style={{ width: '100%' }}
            >
              🔄 再挑战一次
            </button>
            <button
              className="btn btn-secondary"
              onClick={onBack}
              style={{ width: '100%' }}
            >
              🏠 返回首页
            </button>
          </div>
        </div>

        {/* 知识点总结 */}
        {!result.passed && (
          <div className="chapter-card" style={{ marginTop: '20px' }}>
            <div className="chapter-title" style={{ marginBottom: '12px' }}>
              💡 学习建议
            </div>
            <div style={{ fontSize: '14px', lineHeight: '1.8', color: '#6b7280' }}>
              <div style={{ marginBottom: '8px' }}>
                1. 复习{level.description}
              </div>
              <div style={{ marginBottom: '8px' }}>
                2. 重点掌握相关概念和反应原理
              </div>
              <div>
                3. 多做练习题，熟悉题型和解题思路
              </div>
            </div>
          </div>
        )}

        {/* 鼓励语 */}
        {result.passed && (
          <div className="chapter-card" style={{ marginTop: '20px' }}>
            <div style={{
              textAlign: 'center',
              padding: '20px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '12px',
              color: 'white'
            }}>
              <div style={{ fontSize: '32px', marginBottom: '12px' }}>
                🌟
              </div>
              <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
                继续保持！
              </div>
              <div style={{ fontSize: '14px', opacity: 0.9 }}>
                你的化学学习之路正在越走越远！
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultPage;
